import { render } from "./AdminMenu.vue?vue&type=template&id=ff1edc6e&scoped=true"
import script from "./AdminMenu.vue?vue&type=script&lang=js"
export * from "./AdminMenu.vue?vue&type=script&lang=js"

import "./AdminMenu.vue?vue&type=style&index=0&id=ff1edc6e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff1edc6e"]])

export default __exports__